<template>
    <div class="ChartContent">
        <component v-if="componentList[index]" :is="components[componentList[index].config.baseConfig.type]" :class="componentList[index].config.baseConfig.animation?'animate__animated  animate__'+componentList[index].config.baseConfig.animation:''" :key='index' :index='index'></component>
    </div>
</template>
<script setup>
import { defineAsyncComponent, ref,computed  } from 'vue';
import { useStore } from 'vuex';
const props = defineProps({
  index: {
    type: Number,
    default: 0,
  },
});
const index = ref(props.index)
const store = useStore(); 
const componentList = ref(computed(() => store.state.chartData.componentList));
// 批量导入组件
const components = ref({})
const requireComponent = require.context(
  // 其组件目录的相对路径
  '../../ComponentInstance',
  // 是否搜索子目录
  true,
  // 匹配基础名称的正则表达式
  /[\w-]+\.vue$/
)
// 遍历搜索到的文件并导入组件
requireComponent.keys().forEach(fileName => {
  // 获取组件配置
  const componentConfig = requireComponent(fileName)
 
  // 获取组件名称
  let componentName = fileName.replace(/(\.\/|\.vue)/g, '')
  componentName = componentName.split('/').pop().split('.')[0]
//   console.log(componentName.split('/').pop().split('.'));
  // 全局注册组件
  components.value[componentName] = componentConfig.default || componentConfig
})
// 初始化赋值

</script>
<style lang="less">
    
</style>
